const PLATFORM_NAME = 'Missão Futuro'

export function buildPageTitle(moduleLabel?: string, entityName?: string): string {
  const parts = [entityName, moduleLabel, PLATFORM_NAME].filter(Boolean)
  return parts.join(' - ')
}
